<script lang="ts">
  import Radio from '../../../assets/svgs/radio.svelte';
  import RadioSelected from '../../../assets/svgs/radio-selected.svelte';

  type Option = {
    value: string;
    label: string;
    subLabel?: string;
    badge?: string;
    price?: string;
    salePrice?: string;
    originalPrice?: string;
    currency?: string;
    plan?: string;
    trialPeriodDays: number;
  };

  export let customClass: string = '';
  export let name: string = 'radio';
  export let options: Option[] = [];
  export let value: string | undefined = undefined;
</script>

<div class="flex flex-col gap-2 {customClass}">
  {#each options as option}
    <label
      data-testid="radio-input"
      class="flex flex-row items-center gap-6 p-6 outline
        {value === option.value ? 'outline-2' : 'outline-1'}
        {value === option.value ? 'outline-black' : 'outline-sweat-gray-5'}
        {value === option.value ? 'bg-gray-100' : 'bg-white'}
        rounded-md cursor-pointer
        transition-all duration-75"
    >
      {#if option.price !== undefined || option?.currency !== undefined || option?.plan !== undefined}
        <input
          type="radio"
          {name}
          value={option.value}
          bind:group={value}
          style="background-image: none"
          class="plausible-event-name=new_paywall_select_{option?.plan}ly hidden"
          data-price={(option?.price / 100).toFixed(2)}
          data-currency={option?.currency}
          data-plan="{option?.plan}ly"
        />
      {:else}
        <input
          type="radio"
          {name}
          value={option.value}
          bind:group={value}
          style="background-image: none"
          class="hidden"
        />
      {/if}
      {#if value === option.value}
        <div class="flex items-center relative">
          <Radio customClass="text-black" />
          <RadioSelected customClass="text-black absolute animate-scale" />
        </div>
      {:else}
        <Radio customClass="text-gray-300" />
      {/if}

      <span class="flex flex-col">
        <span class="block">
          {#if option.badge}
            <span
              class="text-xs uppercase text-white font-bold bg-primary-500 px-3 py-0.5 rounded-sm w-fit mb-1 -mt-2"
              >{option.badge}</span
            >
          {/if}
          {#if option.trialPeriodDays > 0}
            <span
              class="text-xs uppercase text-gray font-bold bg-gray-200 px-3 py-0.5 rounded-sm w-fit mb-1 -mt-2"
              >{option.trialPeriodDays}-day free trial</span
            >
          {/if}
        </span>
        <span class="text-xl font-bold transition duration-100">
          {#if option.salePrice}
            <span class="line-through text-gray-400">{option.originalPrice}</span>
          {/if}
          {option.label}
        </span>
        {#if option.subLabel}
          <span data-testid="option-sublabel" class="text-sm text-gray-500">{option.subLabel}</span>
        {/if}
      </span>
    </label>
  {/each}
</div>

<style>
  label:hover span.text-xl {
    @apply text-primary-500;
  }
</style>
